import React, { useState,useEffect } from "react";
import CText from "../../common/CText";
import { View } from "react-native";
import CImage from "../../common/CImage";
import CInput from "../../common/CInput";
import CustomButton from "../../common/CustomButton";
import ModalAlert from "../../common/ModalAlert";
import { sendOtpApi,getUserDetails } from "../../api/apiManager";
import { getAllApplicationIds } from "../../api/usedCarLoan";
import Loader from "../../common/Loader";
import OtpModal from "../../common/OtpModal";
import {get} from 'lodash'
import CHeader from "../../common/CHeader";
import {  CreateResponsiveStyle,  DEVICE_SIZES,  useDeviceSize,  } from "rn-responsive-styles";

export default function TrackStatus(props) {
    const styles = useStyles()
    const [mobileNo, setMobileNo] = useState('')
    const [isMobileValid, setMobileValid] = useState(false)
    const [otpModalVisible, setOtpModalVisible] = useState(false)
    const [loading, setLoading] = useState(false);
    const [otpData, setOtpData] = useState(false);
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [alertModal, setAlertModal] = useState({
        title: "",
        status: "",
        message: "",
        navigateScreen: "",
        navigate: '',
        actionButton: "",
    });

    const getProfileDetails = () => {
        setLoading(true);
        getUserDetails()
          .then((res) => {
            if(get(res, "mobileNo", "")){
                setMobileNo((get(res, "mobileNo", "")));
                setMobileValid(true)
            }
            setLoading(false);  
          })
          .catch((err) => {
            setLoading(false);
            console.log("<------------ error in profile data api ----------->");
          });
      };

      useEffect(()=>{
        getProfileDetails()
      },[])

    const getOtp = () => {
        setLoading(true)
        sendOtpApi({ mobileNo: mobileNo, "type": "usedCarLoan" }).then(res => {
            setLoading(false);
            if (res.statusCode == -1017 || res.statusCode == 500 || res.statusCode < 0) {
                setAlertModalVisible(true);
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
            } else {
                setOtpData(res)
                setOtpModalVisible(true)
                setAlertModalVisible(false);
            }
        }).catch(err => { setLoading(false) })
    }

    const onSuccessOtpValidation = () => {
        setOtpModalVisible(false)
        setAlertModalVisible(false);
        getApplicationIds();
    }

    const getApplicationIds = () => {
        setLoading(true);
        getAllApplicationIds({ mobileNo: mobileNo, requestId :  get(otpData, "response.otp", "").toString() }).then(res => {
            setLoading(false)
            if (res?.statusCode === 1076) {
                const { applicationIds } = res.data;
                props.setApplicationIds(applicationIds);
                props.setActiveScreen("TrackStatusApplications");
                props.setFromScreen("")
            } else if (res?.statusCode === -1076) {
                props.setStatusData({
                    statusCode: "",
                    message: "You’ve not applied for Used Car Loan",
                    data: {
                        applicationId: "NE",
                        status: "No application",
                        subStatus: "Never applied",
                        secondaryStatus: "Please apply for loan to see the status"
                    }
                });
                props.setActiveScreen("StatusBlock");
            } else {
                setAlertModal({
                    title: "Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                });
                setAlertModalVisible(true)
            }
        }).catch(err => {
            console.log("getApplicationIds Error:", err);
            setLoading(false);
        })
    }

    return (
        <>
            <View>
                <CHeader onPress = {props.setActiveScreen} title = "Back"  navigation = "CarLoanIndex"></CHeader>
            </View>

            <View style={styles.contentWrapper}>

                <View style={styles.carImageWrapper}>
                    <View style={{ paddingVertical: 6 }}>
                        <CText.usedCarLoanHeader>Track Loan Status</CText.usedCarLoanHeader>
                    </View>
                    <View style={styles.carImage}><CImage.usedCarLoanIndex /></View>
                </View>

                <View style={styles.applyLoanWrapper}>
                    <View style={{ marginTop: 22 }}><CText.headerDesc>{`Please enter your mobile number (Preferably \nlinked with Aadhar & PAN)`}</CText.headerDesc></View>

                    <CInput
                        label='Mobile number'
                        inputWithTopLabel={true}
                        value={mobileNo}
                        onChangeText={setMobileNo}
                        inputType="numeric"
                        pattern="[6-9]{1}[0-9]{9}"
                        onValidation={(isValid) => setMobileValid(isValid)}
                        maxLength={10}
                        keyboardType={'phone-pad'} mandatoryField = {true} />

                    <View style={{ width: 230, height: 44, borderRadius: 22 }}>
                        <CustomButton text="Check Status" onPress={isMobileValid ? getOtp : () => { }} disable={!isMobileValid} />
                    </View>
                </View>
            </View>
            {otpModalVisible && <OtpModal
                data={otpData}
                onSuccess={() => onSuccessOtpValidation()}
                navigation=""
                getOtp={getOtp}
                type  = "usedCarLoan"
            />}
            {loading ? <Loader /> : ""}
            {alertModalVisible && (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert
                        title={alertModal.title}
                        status={alertModal.status}
                        message={alertModal.message}
                        navigateScreen={alertModal.navigateScreen}
                        actionButton={"OK"}
                        onCloseModal={() => setAlertModalVisible(false)}
                    />
                </View>
            )}
        </>

    )
}
const useStyles = CreateResponsiveStyle({

    contentWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingTop: 40,
        justifyContent: "space-between",
        paddingHorizontal: "15%"
    },
    carImage: {
        marginTop: 20
    },
    carImageWrapper: {
        alignItems: "center",
    },
    applyLoanWrapper: {
        gap: 19,
        marginTop: -20
    },
    applyLoanImage: {
        width: 28,
        height: 28
    },
    overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
    },
},
{
        [DEVICE_SIZES.LG]: {
        

        },
        [DEVICE_SIZES.MD]: {
            
        },
        [DEVICE_SIZES.SM]: {
            
        },
        [DEVICE_SIZES.XS]: {
            contentWrapper : {
                flexDirection:"column",
               
            },
            applyLoanWrapper :{
                marginTop:10
            }
            
        }
    }
)

